import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.5 3.5v9.393l7.064 7.607H20.5v-17h-17zm2 8.5V5.5h13v13h-6V12h-7zm1.758 2 3.242 3.492V14H7.258z",
		clipRule: "evenodd"
	})
});
export default SvgComment;
